module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEnable()),
      expression: "isEnable()"
    }],
    style: (_vm.getStyle),
    attrs: {
      "id": "ticker"
    }
  }, [_vm._v("↑now")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4726fee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/timetable/SpTicker.vue
// module id = 698
// module chunks = 0